import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import {  GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { studentNotificationListingModel } from 'common/models/page-models/Student Notification/student-notification-grid-model';
import { studentNotificationModel } from 'common/models/page-models/Student Notification/student-assignment-data-model';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class studentNotificationGridDataService extends GridDataService<studentNotificationListingModel, studentNotificationModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.studentNotificationGrid, http, ss);

      
        
    } 

    createInstance(): studentNotificationListingModel {
        return new studentNotificationListingModel();
    }

    override getGridParams(param): GridPostParams {
        return '';
    }

    override getDeleteUrl(): string {
        return "";
    }
    override getDataParam(): string {

        return 'details';
    }

}
